import React, { useEffect, useRef } from 'react';
import { PAGE_HTML } from './data/page';
import { CHECKOUT_URL, META_PIXEL_ID } from './data/config';

// Every button that sells: hero, offer box, final CTA and the mobile sticky bar.
const BUY_SELECTOR = '[data-buy], .final a.btn, #sticky a.btn';
function loadPixel(id: string) {
  const w = window as any;
  if (!id || w.fbq) return;
  const n: any = w.fbq = function (...args: any[]) {
    n.callMethod ? n.callMethod(...args) : n.queue.push(args);
  };
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  const s = document.createElement('script');
  s.async = true;
  s.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(s);
  w.fbq('init', id);
  w.fbq('track', 'PageView');
}
export function App() {
  const root = useRef<HTMLDivElement>(null);
  useEffect(() => {
    document.title = 'The Argentine Mate Experience — 6 Visual Guides + 4 Bonuses';
    loadPixel(META_PIXEL_ID);
    const el = root.current;
    if (!el) return;
    if (CHECKOUT_URL) {
      // keep the visit's UTMs on the way to the checkout
      const url = new URL(CHECKOUT_URL);
      new URLSearchParams(window.location.search).forEach((v, k) => url.searchParams.set(k, v));
      el.querySelectorAll<HTMLAnchorElement>(BUY_SELECTOR).forEach(a => {
        a.href = url.toString();
      });
    }
    const sticky = el.querySelector<HTMLElement>('#sticky');
    const offer = el.querySelector<HTMLElement>('#offer');
    const onScroll = () => {
      if (!sticky || !offer) return;
      const r = offer.getBoundingClientRect();
      const inOffer = r.top < window.innerHeight && r.bottom > 0;
      sticky.classList.toggle('show', window.scrollY > 600 && !inOffer);
    };
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <div ref={root} dangerouslySetInnerHTML={{
    __html: PAGE_HTML
  }} data-id="element-0" data-mp="sudlkfnv5z8s" />;
}